<template>
  <v-container>
    <v-row justify="center">
      <p>Loading... Please wait</p>
    </v-row>
  </v-container>
</template>


<script>
import { onMounted } from "@vue/composition-api";
import router from "@/router";
import store from "@/store";
import Vue from "vue";
import useShuffle from "@/composables/useShuffle";
import { ref as fbRef, getDatabase, child, get } from "firebase/database";
export default {
  setup() {
    onMounted(async () => {
      window.onbeforeunload = function () {
        return "Are you sure you want to leave?";
      };

      store.commit("setPid", router.app.$route.query.pid);
      if (router.app.$route.query.listname == "fb") {
        console.log("get listname and prime from firebase");
        try {
          let snapshot = await get(
            child(
              fbRef(getDatabase()),
              store.state.experimentName + "/listname"
            )
          );
          let fbListname = snapshot.val();
          store.commit("setListname", fbListname);
         
          snapshot = await get(
            child(
              fbRef(getDatabase()),
              store.state.experimentName + "/prime"
            )
          );
          let prime = snapshot.val();
          store.commit("setPrime", prime);
        } catch (error) {
          console.log(error);
          Vue.prototype.$dialog.error({
            text: "Could not load listname or prime from Firebase",
            title: "Error",
          });
        }
      } else {
        console.log("get listname from URL parameters");
        store.commit("setListname", router.app.$route.query.listname);
        store.commit("setPrime", router.app.$route.query.prime);
      }


      await getLists(store.state.listname);
      //console.log(getLists);

      store.commit("setLocked", false);
      router.push("/audioTest");
    });

    const getLists = async (listName) => {
      let fullList = [];
      const response = await fetch("lists/" + listName + ".json");
      const items = await response.json();
      const { shuffle } = useShuffle();

      for (let item of items) {
        //console.log(item, shuffle);
        
        if (item.type == "same_different") {
          item.audio = shuffle(item.audio);
          for(let j of item.audio){
            let deconstruct = { ...item };
            delete deconstruct.audio;
            deconstruct.audio = j
            fullList.push(deconstruct);  
          }
        } else if (item.type == "cloze_block") {
          const clozeBlockResponse = await fetch("lists/" + item.file);
          item.cloze_items = await clozeBlockResponse.json();
          item.cloze_items = shuffle(item.cloze_items);
          for (let i of item.cloze_items) {
            let deconstruct = { ...item };
            delete deconstruct.cloze_items;
            fullList.push({ ...i, ...deconstruct });
          }
        } else {
          fullList.push(item);
        }
        
      }
      store.commit("setList", fullList);
    };
  },
};
</script>